<div class="layout-column custom-panel full-width full-height padding-10 gap-5">
  <div class="header layout-column justify-content-between gap-5">
    <div class="layout-row justify-content-between align-items-center">
      <div class="layout-row gap-5 align-items-center">
        <bringoz-icon iconName="reset" class="gray-100"></bringoz-icon>
        <span class="flex font-weight-600 gray-100">{{'JobSplit.Panel.Header' | translate}}</span>
      </div>
      <bringoz-button type="tertiary"
                      (click)="close()"
                      size="sm">
        <bringoz-icon iconName="close"></bringoz-icon>
      </bringoz-button>
    </div>
    <div class="border-bottom"></div>
  </div>

  <div class="flex layout-column gap-10 overflow-y-auto">
    <div *ngIf="isAnySubJobInLockedRoute" class="layout-row padding-5 gap-5 locked-job-warning">
      <bringoz-icon fill="#910000" iconName="error-outline"></bringoz-icon>
      <span *ngIf="isCurrentJobInLockedRoute; else checkOtherJob">{{'JobSplit.Panel.LockedJobInRoute' | translate}}</span>
      <ng-template #checkOtherJob>
        <span *ngIf="isOtherJobInLockedRoute">{{'JobSplit.Panel.OtherJobInLockedRoute' | translate}}</span>
      </ng-template>
    </div>
    <div *ngIf="isAnyJobDispatched" class="layout-row padding-5 gap-5 locked-job-warning">
      <bringoz-icon fill="#910000" iconName="error-outline"></bringoz-icon>
      <span>{{'JobSplit.Panel.DispatchedRoute' | translate}}</span>
    </div>
    <div *ngIf="isUndoBlockedByStep" class="layout-row padding-5 gap-5 locked-job-warning">
      <bringoz-icon fill="#910000" iconName="error-outline"></bringoz-icon>
      <span>{{'JobSplit.Panel.UndoBlockedByStep' | translate}}</span>
    </div>
    <span *ngIf="otherJobRoute">{{ 'JobSplit.Panel.RoutedWarning' | translate:{ routeId: otherJobRoute?.id || '' } }}</span>
    <div class="flex layout-column" *ngIf="jobSuggestions.suggestionInformation.type === 'SPLIT_PACKAGES'; else splitByLocation">
      <!-- Reverse split by packages -->
      <span>{{ 'JobSplit.Panel.ByPackageDescription' | translate }}</span>
      <div class="padding-10-5">
        <div class="layout-column" *ngFor="let pkg of otherSubJob?.packages; let last = last">
          <div class="package-row layout-row align-items-center gap-5">

            <div *ngIf="pkg.barcode" class="flex-25 layout-row layout-align-start center gap-5">
              <span class="text-ellipsis" [ngbTooltip]="pkg.barcode">{{ pkg.barcode }}</span>
              <span>|</span>
            </div>

            <div class="layout-row justify-content-around gap-5">
              <span>{{ pkg.weight | bringozWeight:true:'':true }} </span>
              <span>|</span>
            </div>


            <div class="layout-row justify-content-around gap-5">
              <span>{{ pkg.pallets ?? 0 }}</span>
              <span translate>Pallets</span>
              <span>|</span>
            </div>

            <div class="layout-row justify-content-around gap-5">
              <span>{{ (pkg.volume) | bringozVolume:true }}</span>
              <span>|</span>
            </div>

            <span>{{'Count' | translate}}: {{ pkg.count }}</span>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>

    <ng-template #splitByLocation>
      <!-- Reverse split by location -->
      <div class="layout-column gap-5">
        <span>{{ 'JobSplit.Panel.ByLocationDescription' | translate }}</span>
        <ul class="layout-column">
          <li class="layout-row gap-5 layout-align-start-center" *ngFor="let subJob of subJobs; let i = index; let last = last">
            <div class="dot"></div>
            <span class="text-width-limit-50">{{subJob.stops[0].address | bringozAddress}}</span>
            <bringoz-icon iconName="arrow-right"></bringoz-icon>
            <span class="text-width-limit-50">{{subJob.stops[1].address | bringozAddress}}</span>
          </li>
        </ul>
      </div>

      <div class="layout-column padding-top-5 gap-5">
        <span>{{ 'JobSplit.Panel.ByLocationResult' | translate }}</span>
        <div class="layout-row gap-5 layout-align-start-center">
          <div class="dot"></div>
          <span class="text-width-limit-50">{{subJobs[0].stops[0].address | bringozAddress}}</span>
          <bringoz-icon iconName="arrow-right"></bringoz-icon>
          <span class="text-width-limit-50">{{subJobs[subJobs.length-1]?.stops?.[1]?.address | bringozAddress}}</span>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="layout-column gap-5">
    <div class="border-top"></div>
    <div class="layout-row justify-content-between">
      <bringoz-button size="sm" type="tertiary"
                      (click)="close()">
        <span translate>Cancel</span>
      </bringoz-button>
      <div class="layout-row gap-5">
        <bringoz-button size="sm" theme="secondary"
                        [isDisabled]="!canReverseSplit()"
                        (click)="reverseJobSplit()">
          <span translate>Reverse</span>
        </bringoz-button>
      </div>
    </div>
  </div>

</div>
